import Vue from 'vue'

export const queryApplicationList = params => {
  return Vue.http.post('/virus/securityAssessment/queryApplicationList', params)
}

export const getReport = params => {
  return Vue.http.post('/virus/securityAssessment/downloadReport', params)
}

export const downloadCertification = params => {
  return Vue.http.post('/virus/securityAssessment/downloadCertification', params)
}

export const queryList = params => {
  return Vue.http.post('/virus/securityAssessment/queryList', params)
}

export const getAuditInfo = params => {
  return Vue.http.post('/virus/securityAssessment/getAuditInfo', params)
}
